import actions from './actions';

const {
  ADD_ENG_BEGIN,
  ADD_ENG_SUCCESS,
  ADD_ENG_ERR,

  ADD_VENDOR_ENG_BEGIN,
  ADD_VENDOR_ENG_SUCCESS,
  ADD_VENDOR_ENG_ERR,

  GET_ENG_BEGIN,
  GET_ENG_SUCCESS,
  GET_ENG_ERR,

  GET_VENDOR_ENG_BEGIN,
  GET_VENDOR_ENG_ERR,
  GET_VENDOR_ENG_SUCCESS,

  UPDATE_ENG_BEGIN,
  UPDATE_ENG_SUCCESS,
  UPDATE_ENG_ERR,

  DELETE_ENG_BEGIN,
  DELETE_ENG_SUCCESS,
  DELETE_ENG_ERR,
} = actions;

const initialState = {
  data: [],
  loading: false,
  error: null,

  add_vendor_eng_loading: false,
  add_vendor_eng_data: null,
  add_vendor_eng_error: false,

  get_vendor_eng_loading: false,
  get_vendor_eng_data: [],
  get_vendor_eng_error: false,
};

const engineerReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case ADD_ENG_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case ADD_ENG_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case ADD_ENG_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case ADD_VENDOR_ENG_BEGIN:
      return {
        ...state,
        add_vendor_eng_loading: true,
        add_vendor_eng_data: null,
        add_vendor_eng_error: false,
      };

    case ADD_VENDOR_ENG_SUCCESS:
      return {
        ...state,
        add_vendor_eng_loading: false,
        add_vendor_eng_data: data,
        add_vendor_eng_error: false,
      };

    case ADD_VENDOR_ENG_ERR:
      return {
        ...state,
        add_vendor_eng_loading: false,
        add_vendor_eng_data: null,
        add_vendor_eng_error: true,
      };

    case GET_VENDOR_ENG_BEGIN:
      return {
        ...state,
        get_vendor_eng_loading: true,
        get_vendor_eng_data: [],
        get_vendor_eng_error: false,
      };

    case GET_VENDOR_ENG_SUCCESS:
      return {
        ...state,
        get_vendor_eng_loading: false,
        get_vendor_eng_data: data,
        get_vendor_eng_error: false,
      };

    case GET_VENDOR_ENG_ERR:
      return {
        ...state,
        get_vendor_eng_loading: false,
        get_vendor_eng_data: [],
        get_vendor_eng_error: true,
      };

    case GET_ENG_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case GET_ENG_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case GET_ENG_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case DELETE_ENG_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case DELETE_ENG_SUCCESS:
      return {
        ...state,
        error: false,
        data,
        loading: false,
      };

    case DELETE_ENG_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case UPDATE_ENG_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_ENG_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };

    case UPDATE_ENG_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { engineerReducer };
